import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Download, Share, PlusSquare } from "lucide-react";

let deferred = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; window.dispatchEvent(new Event("omi-install-ready")); });
}
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export function InstallApp({ className = "", label = "Install app", compact = false }) {
  const [ready, setReady] = useState(!!deferred);
  const [help, setHelp] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());
  useEffect(() => {
    const on = () => setReady(true);
    const done = () => setInstalled(true);
    window.addEventListener("omi-install-ready", on);
    window.addEventListener("appinstalled", done);
    return () => { window.removeEventListener("omi-install-ready", on); window.removeEventListener("appinstalled", done); };
  }, []);
  if (installed) return null;
  const click = async () => {
    if (deferred) { deferred.prompt(); const r = await deferred.userChoice; if (r.outcome === "accepted") setInstalled(true); deferred = null; setReady(false); }
    else setHelp(true);
  };
  return (
    <>
      <Button size="sm" variant="outline" onClick={click} className={className} data-testid="install-app-btn" data-ready={ready ? "1" : "0"}><Download className={`h-4 w-4 ${compact ? "sm:mr-1.5" : "mr-1.5"}`} />{compact ? <span className="hidden sm:inline">{label}</span> : label}</Button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent className="w-[calc(100%-2rem)] max-w-sm rounded-xl" data-testid="install-help-dialog">
          <DialogHeader><DialogTitle>Install OMI CRM on your phone</DialogTitle></DialogHeader>
          {isIOS() ? (
            <ol className="text-sm space-y-2 list-decimal pl-5">
              <li>Open this page in <b>Safari</b>.</li>
              <li>Tap <Share className="inline h-4 w-4" /> <b>Share</b> at the bottom.</li>
              <li>Tap <PlusSquare className="inline h-4 w-4" /> <b>Add to Home Screen</b>, then <b>Add</b>.</li>
            </ol>
          ) : (
            <ol className="text-sm space-y-2 list-decimal pl-5">
              <li>Open this page in <b>Chrome</b> on your Android phone.</li>
              <li>Tap the <b>⋮</b> menu at the top right.</li>
              <li>Tap <b>Install app</b> or <b>Add to Home screen</b>.</li>
            </ol>
          )}
          <p className="text-xs text-muted-foreground">The OMI icon appears on your home screen and opens straight to today's calling list.</p>
        </DialogContent>
      </Dialog>
    </>
  );
}
